import React from 'react';
import PropTypes from 'prop-types';
import { componentPropType } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Group = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    label
  } = _ref;
  return /*#__PURE__*/_jsx("optgroup", {
    label: label,
    ref: ref,
    children: children
  });
});
Group.displayName = 'Group';
export default Group;
Group.propTypes = {
  children: componentPropType('Item'),
  /**
   * The label for the group.
   */
  label: PropTypes.string.isRequired
};